import type { ReactNode } from "react"
import { ThemeProvider } from "next-themes"
import { AccessibilitySettingsProvider } from "@/lib/accessibility-settings"
import { AuthProvider } from "@/lib/auth-context"
import { DisplayAspectProvider } from "@/lib/display-aspect"
import { QueryProvider } from "@/lib/query-provider"
import { SemanticColorsProvider } from "@/lib/semantic-colors"
import { ThemePaletteProvider } from "@/lib/theme-palette"
import { Toaster } from "sonner"
import { AnalyticsIdentity } from "@/components/analytics-identity"

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
      <ThemePaletteProvider>
        <SemanticColorsProvider>
          <DisplayAspectProvider>
            <AccessibilitySettingsProvider>
              <AuthProvider>
                <AnalyticsIdentity />
                <QueryProvider>{children}</QueryProvider>
                <Toaster richColors closeButton position="top-center" />
              </AuthProvider>
            </AccessibilitySettingsProvider>
          </DisplayAspectProvider>
        </SemanticColorsProvider>
      </ThemePaletteProvider>
    </ThemeProvider>
  )
}
